import type { StreamReaction } from '@stream-io/video-react-sdk'

export const ET_TIMEZONE = 'America/New_York'

export const statusColors = {
  SCHEDULED: 'bg-green-500',
  WAITING_FOR_TEACHER: 'bg-orange-500',
  IN_PROGRESS: 'bg-blue-500',
  COMPLETED: 'bg-yellow-500',
  CANCELLED: 'bg-red-500',
}

export const statusString = {
  SCHEDULED: 'Scheduled',
  WAITING_FOR_TEACHER: 'Waiting for Teacher',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
}

export const JOIN_CLASS_WAITING_PERIOD = 5 * 60 * 1000

export const reactions: StreamReaction[] = [
  {
    type: 'reaction',
    emoji_code: ':like:',
  },
  {
    type: 'reaction',
    emoji_code: ':dislike:',
  },
  {
    type: 'reaction',
    emoji_code: ':heart:',
  },
  {
    type: 'reaction',
    emoji_code: ':fireworks:',
  },
  {
    type: 'reaction',
    emoji_code: ':smile:',
  },
]
